// src/modules/app-views/companies/pages/Init/components/tableColumns/cnpjColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { parseCnpjToDisplay, returnOnlyNumbers } from 'utils/helpers';
import { isValidCnpj } from 'utils/validation';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function cnpjColumn(buildColumnProps, options = {}) {
  const {
    key = 'cnpj',
    title = 'cnpj',
    dataIndex = ['cnpj', 'value'],
    width = 180,
    columnProps = { sort: true, search: true, searchValidate: isValidCnpj, searchDecorator: returnOnlyNumbers },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps('cnpj.value', columnProps),
    render: (_, r) => {
      const value = r?.cnpj?.value;
      return value ? parseCnpjToDisplay(returnOnlyNumbers(value)) : '—';
    },
  };
}

export default cnpjColumn;
